/**
 * Material(ien) eines Meshes freigeben — inklusive ihrer Texturen.
 *
 * DIE FALLE, gegen die es hier geht (Jans Fund 04.08.2026: "das Textelement
 * STARK wollte ich in COOL umbenennen — wird nicht angezeigt im Preview"):
 *
 * Troika-Text liefert ein Material-ARRAY, sobald eine Outline / ein
 * Schlagschatten konfiguriert ist ([outline, fill]). Der frühere Aufräum-Code
 *
 *     if (mesh.material.map) mesh.material.map.dispose()
 *
 * fiel darauf herein: ein Array hat SELBST eine `.map`-Methode. Die Prüfung
 * hielt die Array-Funktion für eine Textur und rief `.dispose()` darauf auf →
 * "material.map.dispose is not a function". Der Wurf brach den Text-Austausch
 * ab, das alte Mesh blieb stehen und die Vorschau zeigte weiter den alten
 * Text. Ohne Outline lief derselbe Code durch — daher "mal geht es, mal nicht".
 *
 * Dieselbe Array-Eigenheit hat uns schon bei den Material-Eigenschaften
 * getroffen; sie ist bei Troika die Regel, nicht die Ausnahme.
 */

// Absichtlich lose typisiert: die Funktion soll auch mit fremden/legacy
// Objekten klarkommen, die nicht sauber als THREE.Material typisiert sind.
interface EntsorgbaresMaterial {
    map?: { dispose?: () => void } | null;
    dispose?: () => void;
}

export function disposeMaterials(
    material: EntsorgbaresMaterial | EntsorgbaresMaterial[] | null | undefined,
): number {
    if (!material) return 0;
    const liste = Array.isArray(material) ? material : [material];
    let freigegeben = 0;
    for (const m of liste) {
        if (!m) continue;
        // `m.map?.dispose` statt `if (m.map)`: bei einem versehentlich
        // durchgereichten Array waere `.map` die Array-Funktion ohne dispose —
        // die Optional-Verkettung faellt dann sauber durch.
        if (typeof m.map?.dispose === "function") m.map.dispose();
        if (typeof m.dispose === "function") {
            m.dispose();
            freigegeben += 1;
        }
    }
    return freigegeben;
}
